import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSettingsStore, useUserUUID, } from '@annunciate/core';
import { USER_GET } from '@annunciate/query/dist/queries/user';
import { useQuery } from './base';
import { NetworkRequestError } from '../utils';
const isAuthError = (error) => {
    return error?.response?.status === 200 &&
        error?.response?.errors[0]?.extensions?.code === 'UNAUTHENTICATED';
};
export const useUserQuery = () => {
    const client = useQueryClient();
    const uuid = useUserUUID();
    const { data, isPending, isSuccess, isError, error, refetch, } = useQuery(['user', uuid || 'public'], USER_GET, undefined, {
        retry: (_count, error) => {
            return !isAuthError(error);
        },
    }, undefined, (error) => {
        if (!isAuthError(error) && !(error instanceof NetworkRequestError)) {
            throw error;
        }
        return { user: undefined, entitlements: undefined };
    });
    useEffect(() => {
        if (!isSuccess)
            return;
        const user = data?.user;
        const userTheme = user?.settings?.theme;
        useSettingsStore.getState().setThemeMode(userTheme);
        client.setQueryData(['entitlement', user?.id || 'public'], () => {
            const entitlementsMap = data?.entitlements?.reduce((acc, entitlement) => {
                acc[entitlement.identifier] = true;
                return acc;
            }, {}) || {};
            return {
                version: Date.now(),
                entitlements: entitlementsMap,
            };
        });
    }, [
        isSuccess,
        data?.user?.id,
    ]);
    useEffect(() => {
        if (error && !isAuthError(error)) {
            throw error;
        }
    }, [error]);
    return {
        user: data?.user,
        isPending,
        isError,
        refetch
    };
};
//# sourceMappingURL=useUserQuery.js.map